import React from 'react'
import SEO from '../components/SEO'
import GallerySection from '../components/GallerySection'

export default function GalleryPage() {
  return (
    <>
      <SEO
        title="Galleri"
        description="Billedgalleri fra Insightly Care - glimt fra kontorlivet, kandidatsamtaler og rekruttering i dansk IT-miljø."
      />

      {/* Header Banner */}
      <section className="bg-white pt-16 sm:pt-20 pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-4xl sm:text-5xl font-black text-black tracking-tight">
              Billedgalleri
            </h1>
            <p className="text-lg text-black mt-3 leading-relaxed">
              Tag et kig bag kulisserne hos Insightly Care.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Section Connected via CMS slug */}
      <div className="pb-12">
        <GallerySection gallerySlug="rekruttering-og-kontor" />
      </div>
    </>
  )
}
